import { getAttachmentSelectionKey } from "../utils/getAttachmentSelectionKey";

/**
 * Re-groups the full raw attachment list into "same file, different version"
 * groups, mirroring TableListFiles.compileFiles (src/views/ProjectSheet/ListFiles/TableListFiles.js).
 * Needed here so the release flow can find OLDER versions of the attachments
 * the user selected, without depending on TableListFiles' internal state.
 */
export function groupAttachmentsForRelease(allData, attachmentContext, type, condition) {
  const data = Array.isArray(allData) ? allData : [];

  const allGroup = attachmentContext.compileAll(data, condition);
  const filteredAllGroup = Object.fromEntries(
    Object.entries(allGroup).map(([key, files]) => [
      key,
      files.filter((file) => file.fileId && file.fileName),
    ])
  );
  const chapterCompiled = attachmentContext.compiledChapter(data, type, condition);
  const materialCompiled = attachmentContext.compileMaterial(data, "Material Complementar");

  const mergeGroups = {
    ...filteredAllGroup,
    ...materialCompiled,
    ...chapterCompiled,
  };

  return Object.values(mergeGroups).filter((item) => item?.[0]?.type?.id !== 1211);
}

const isReleasedToAnyDestination = (attachment) =>
  !!attachment?.releaseManagement?.channel ||
  !!attachment?.releaseManagement?.production ||
  !!attachment?.releaseManagement?.cultureHub;

/**
 * For each selected attachment, finds sibling versions (same group, different id)
 * that are currently released (Canal and/or Produção), excluding versions that
 * are themselves part of the selection. Returns a deduplicated map keyed by
 * getAttachmentSelectionKey.
 */
export function findReleasedSiblingVersions(selectedAttachments, groups) {
  const selectedIds = new Set(selectedAttachments.map((a) => a.id));
  const siblingsByKey = {};

  selectedAttachments.forEach((selected) => {
    const group = groups.find((g) => g.some((item) => item.id === selected.id));
    if (!group) return;

    group
      .filter((item) => item.id !== selected.id && !selectedIds.has(item.id))
      .filter(isReleasedToAnyDestination)
      .forEach((sibling) => {
        const key = getAttachmentSelectionKey(sibling);
        if (key && !siblingsByKey[key]) siblingsByKey[key] = sibling;
      });
  });

  return siblingsByKey;
}
